import { SystemPropertyModel } from '@akin-home/system-properties';
import { getSystemPropertyQuery } from '@akin-home/system-properties-frontend';
import { useQuery } from 'react-query';
import { system_property_query_keys } from './query_keys';

export const useGetSystemProperty = (name: string) =>
  useQuery(
    system_property_query_keys.detail(name),
    () => getSystemPropertyQuery({ name }),
    {
      select: ({ data }) =>
        data.getSystemProperty
          ? SystemPropertyModel.parse(data.getSystemProperty)
          : undefined,
    }
  );
